<template>
  <div>
    <!-- Primary Page Layout
    ==================================================-->

    <account-header settingName="Reservation"></account-header>
    <div class="row justify-center">
      <div class="col-lg-2"></div>
      <div class="col-lg-8">
        <h3 class="mt-4"></h3>
        <!-- <div class="row mt-4 mb-4"> -->
          <div class="col-md-12">
            <div class="section padding-top z-bigger">
              <div class="container">
                <div class="row justify-content-center padding-bottom-smaller">
                  <div class="col-md-8">
                    <div class="subtitle with-line text-center mb-4">Hello!</div>
                    <h3 class="text-center padding-bottom-small">Please provide your details below.</h3>
                  </div>
                  <div class="section clearfix"></div>
                  <div class="col-md-8 mt-2 ajax-form">
                      <label class="label col-md-12">Name</label>

                      <input name="name"
                        type="text"
                        placeholder="Enter Your Name: *"
                        autocomplete="off"
                        v-model="requestDetails.name">
                    </div>
                  <div class="section clearfix"></div>
                  <div class="col-md-4 ajax-form">
                    <label class="label col-md-12">Phone Number</label>
                    <input name="phone_number"
                      type="text"
                      placeholder="Enter Your Phone Number: *"
                      autocomplete="off"
                      v-model="requestDetails.phoneNumber"
                      >
                  </div>
                  <div class="col-md-4 mt-4 mt-md-0 ajax-form">
                    <label class="label col-md-12">Email</label>
                    <input name="email"
                      type="text"
                      placeholder="Enter Your E-Mail Address: *"
                      autocomplete="off"
                      v-model="requestDetails.email"
                      >
                  </div>
                  <div class="section clearfix"></div>
                    <!-- <div class="col-md-8 mt-2 ajax-form">
                      <input name="phone_number" type="text" placeholder="Phone Number: *" autocomplete="off">
                    </div>
                  <div class="section clearfix"></div> -->
                  <div class=" col-md-8 mt-4" >
                    <div class="row p-1">
                      <label class="label col-md-6">Check In Date</label>
                      <label class="label col-md-6">Check Out Date</label>
                      <div class="section clearfix"></div>
                    </div>
                  </div>
                  <div class=" col-md-8 ajax-form input-daterange input-group" id="flight-datepicker" >
                    <div class="row p-1">
                      <div class="col-md-6 ajax-form">
                        <input name="checkin_date"
                          id="start-date"
                          type="text"
                          placeholder="Select Check in Date: *"
                          autocomplete="off"
                          data-date-format="DD, MM d"
                          >
                      </div>


                      <div class="col-md-6 ajax-form">
                        <input
                          name="checkout_date"
                          id="end-date"
                          type="text"
                          placeholder="Select Check out Date: *"
                          autocomplete="off"
                          data-date-format="DD, MM d"
                          >
                      </div>
                    </div>

                  </div>

                  <div class="section clearfix"></div>
                  <div class=" col-md-8 mt-4 mt-md-0 ajax-form row">
                    <div class="col-md-6 mt-2 ajax-form">
                      <label class="label col-md-12">Number of guests</label>
                      <input
                        name="number_of_guests"
                        type="number"
                        placeholder="Enter The Number of Guests: *"
                        autocomplete="off"
                        v-model="requestDetails.numberOfGuests"
                        >
                    </div>
                    <div class="col-md-6 mt-2 ajax-form">
                      <label class="label col-md-12">Number of Rooms</label>
                      <input
                        name="number_of_rooms"
                        type="number"
                        placeholder="Enter The Number of Rooms: *"
                        autocomplete="off"
                        v-model="requestDetails.numberOfRooms"
                        >
                    </div>
                  </div>
                  <div class="section clearfix"></div>
                  <div class="col-md-8 mt-4 ajax-form">
                    <label class="label col-md-12">Additional Message</label>
                    <textarea
                      name="message"
                      placeholder="Additional Message"
                      v-model="requestDetails.additionalMessage"></textarea>
                  </div>

                  <div class="section clearfix"></div>
                  <div class="col-md-8 mt-3 ajax-checkbox">
                    <ul class="list">
                      <!-- <li class="list__item">
                        <label class="label--checkbox">
                          <input type="checkbox" class="checkbox">
                          collect my details through this form
                        </label>
                      </li> -->
                      <li class="list__item">
                        <label class="label--checkbox">
                          <span class="text-danger">***</span>For security Reasons, do not enter your card details.
                        </label>
                      </li>
                      <li class="list__item">
                        <label class="label--checkbox">
                          Phone Reservation  call : +234 02084 461770
                        </label>
                      </li>
                    </ul>
                  </div>
                  <div class="section clearfix"></div>
                  <div class="col-md-8 mt-3 ajax-form text-center">
                    <button class="send_message" id="send" data-lang="en" @click="submitDetails($event)">
                      <span>submit</span>
                    </button>
                  </div>
                  <div class="section clearfix"></div>
                  <div class="col-md-8 padding-top-bottom">
                    <div class="sep-line"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import jQuery from 'jquery'
import Constants from '@/common/Constants.js'
import accountHeader from "@/components/accountHeader.vue";


// (function ($) {
//   $(document).on('click', '#send', function(event){
//     event.preventDefault();

//     alert("yeeeeeeeeeeeeeeee");
//   });
// })(jQuery);

export default {
  name: "bookingForm",
  data(){
    return {
      requestDetails : {
        name: '',
        email:'',
        phoneNumber: '',
        checkInDate: '',
        checkOutDate: '',
        numberOfGuests: '',
        numberOfRooms: '',
        additionalMessage: ''
      }
    }
  },
  components: { "account-header": accountHeader },
  methods : {
    submitDetails(event){
      let loaderContainer = $('.loader');
      let loader = $('.loader__figure');
      loaderContainer.attr("style", "");
      loader.attr("style", "");

      this.requestDetails.checkInDate = $('#start-date').val();
      this.requestDetails.checkOutDate = $('#end-date').val();



      if(this.validateQuery(this.requestDetails)){

        this.$http.post(Constants.API_SUBMIT_RESERVATION_URL, this.requestDetails)
        .then((response) => {

          // loaderContainer.css({"display": "none"});
          // loader.css({"display" :"none"});
          // alert('Mail sent, we\'ll get back to you a soon as we can');

        })
        .catch(function (error) {
          if (error.response) {

            if(error.response.status == 400){
              var message = "Please, fill the form correctly."
              alert(message);
            }else{
              var message = "Unable to complete request."
              // alert(message);
            }


            // loaderContainer.css({"display": "none"});
            // loader.css({"display" :"none"});

          }
        });

        loaderContainer.css({"display": "none"});
        loader.css({"display" :"none"});
        alert('Mail sent, we\'ll get back to you a soon as we can');

      }else{
        alert('Please Fill in the form correctly');

        loaderContainer.attr("style", "display:none");
        loader.attr("style", "display:none");

      }
      // console.log(this.requestDetails);
    },

    validateQuery(query){
      if(
          query.name != '' &&
          query.email != '' &&
          query.phoneNumber != '' &&
          query.checkInDate != '' &&
          query.checkOutDate != '' &&
          query.numberOfGuests != 0 &&
          isNaN(query.numberOfGuests) != true &&
          query.numberOfRooms != 0 &&
          isNaN(query.numberOfRooms) != true
      ){
          return true;
      }

      return false;
    },

    closeLoader(){
      let loaderContainer = document.getElementsByClassName('loader');
      let loader = document.getElementsByClassName('loader');
      loaderContainer[0].style = null;
      loader[0].style = null;

    }
  }

  // components: {
  //   headerNav
  // }
};
</script>
<style scoped>
#flight-datepicker input{
    color: #737373 !important;
    border-right:0;
    text-align: center;
    border-left:0;
    border-top:0;
    border-bottom: 1px solid rgba(200, 200, 200, .7);

    font-family: 'Roboto', sans-serif;
    font-weight: 300;
    font-size: 15px;
    line-height: 1.7;
    font: 400 13.3333px Arial;
    text-transform: none;

}
#flight-datepicker input:focus,
#flight-datepicker input:active{
	border-color: #6dc234;
}

#flight-datepicker input::placeholder {
  color: #999999;
}
.label{
  text-align: center;
  align-content: center;
  margin-top: 10px;
}
</style>

